import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DialogType, IconType, NavigationData } from '@pt/pt-models';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WorkspaceItem, WorkspaceMoveRequest } from '@primatoo-ms-organization';

@Component({
  selector: 'pt-move-item-dialog',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{ title | async }}</h4>
    </div>

    <div class='modal-body'>
      <form [formGroup]='formGroup'>
        <div class='form-group'>
          <label class="form-label">{{ 'LABELS.NAME' | translate }}</label>
          <input type='text'
                 autocomplete='off'
                 formControlName='name'
                 class='form-control form-control-sm'
          >
        </div>

        <!--FOLDER----------------------------------------------------------------->
        <ng-template #popContentFolderContent class='p-0'>
          <pt-resource-navigation
            [title]="'TITLE.SELECT_FOLDER' | translate"
            [data]='folders'
            [selectedResourceId]='selectedFolder?.id'
            (clickClose)='popContentFolder.close()'
            (clickItem)='selectFolder($event)'>
          </pt-resource-navigation>
        </ng-template>

        <div class='tree-selector' *ngIf='true'>
          <label class="form-label">{{ 'LABELS.FOLDER' | translate }} <span
            *ngIf='true' class='text-danger'>*</span>
          </label>
          <div class='input-group input-group-sm mb-3'>
            <span class='input-group-text '>
              <pt-icon [key]="'folder.svg'" [size]='14' [iconType]="SVG"></pt-icon>
            </span>
            <input type='text'
                   autocomplete='off'
                   formControlName='folder'
                   class='form-control form-control-sm form-readonly--custom'
                   [ngbPopover]='popContentFolderContent'
                   [autoClose]="'outside'"
                   #popContentFolder='ngbPopover'
                   triggers='manual'
                   readonly
                   placement='top'
                   (click)='chooseFolder()'
                   placeholder="{{'PLACEHOLDERS.FOLDER' | translate}}">
            <button type='button' class='btn-close tree-selector-clean font-10' aria-label='Close'
                    (click)='cleanFolder()'>
              <!--              <span aria-hidden='true'>&times;</span>-->
            </button>
          </div>
        </div>

      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]='formGroup?.invalid'
              (click)='confirm(); $event.stopPropagation()'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </button>

      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `,
  styles: [`
    .form-readonly--custom {
      background: white !important;
    }

    .tree-selector {
      margin-bottom: 16px;
    }

    .tree-selector-clean {
      position: absolute;
      right: 7px;
      font-size: 7px !important;
      top: 8px;
    }
  `]
})
export class MoveItemDialogComponent implements OnInit {
  @Input() title: Observable<string>;

  @Input() resource: WorkspaceItem;

  @Input() folders: NavigationData[];

  @ViewChild('popContentFolder') popContentFolder;

  public formGroup: FormGroup;

  public selectedFolder: NavigationData;

  DT = DialogType;
  SVG = IconType.SVG;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    if (this.resource?.parentId !== null && this.resource?.parentId !== undefined) {
      this.selectedFolder = this.folders?.find(f => f.id === this.resource?.parentId);
    }

    this.formGroup = new FormGroup({
      name: new FormControl({value: this.resource?.name, disabled: true}),
      folder: new FormControl({value: this.selectedFolder?.name, disabled: false}, [Validators.required])
    });

  }

  cleanFolder() {
    this.formGroup?.controls?.folder?.setValue(null);
  }

  chooseFolder() {
    this.popContentFolder.open();
  }

  selectFolder(navigationData: NavigationData) {
    this.popContentFolder.close();
    this.selectedFolder = navigationData;
    this.formGroup.controls.folder.setValue(this.selectedFolder?.name);
  }

  confirm() {
    const response = {
      parentId: this.selectedFolder.id
    } as WorkspaceMoveRequest;

    this.activeModal.close(response);
  }
}

